import * as constants from '../../constants'

export const TRACKER_EVENT = Object.freeze({
  TRIM: 'trim',
  SNAP: 'snap',
  REMOVE_FROM_TIMELINE: 'remove_from_timeline',
  ADD_TO_TIMELINE: 'add_to_timeline',
  TRACK_MENU_ENGAGEMENT: 'track_menu_engagement',
  TOOLBAR_ENGAGEMENT: 'toolbar_engagement',
  EDIT_TRACK_ENGAGEMENT: 'edit_track_engagement',
  TIMELINE_ENGAGEMENT: 'timeline_engagement',
  VOLUME_ENGAGEMENT: 'volume_engagement',
  OVERLAYS_ENGAGEMENT: 'overlays_engagement',
  CROP_ENGAGEMENT: 'crop_engagement',
  VIDEO_SETTINGS_ENGAGEMENT: 'video_settings_engagement',
  SIDE_PANEL_ENGAGEMENT: 'sidepanel_engagement',
  CTA_BUTTON: 'cta_button',
  LIBRARY_FILTERS: 'library_filters',
  UPLOAD_TO_LIBRARY: 'upload_to_library',
  SEARCH_RESULTS: 'search_results',
  LIBRARY_ENGAGEMENT: 'library_engagement',
  PLAYER_ENGAGEMENT: 'player_engagement',
  JUMP_TO_STREAM: 'jump_to_stream',
  AUDIO_ENGAGEMENT: 'audio_engagement',
  STREAMS_TABLE_ENGAGEMENT: 'streams_table_engagement',
  POST_WIZARD_PUBLISH: 'post_wizard_publish',
  POST_WIZARD_ENGAGEMENT: 'post_wizard_engagement',
  FILTERS_ENGAGEMENT: 'filters_engagement',
  LABELS_ENGAGEMENT: 'labels_engagement',
  STORY_PAGE_ENGAGEMENT: 'story_page_engagement',
  ADDITIONAL_ACTION_ENGAGEMENT: 'additional_action_engagement',
  PREVIEW_ENGAGEMENT: 'preview_engagement',
  CTA_CONFIG_ENGAGEMENT: 'cta_config_engagement',
  CREATE_VIDEO: 'create_video',
  SWITCH_MODE_ENGAGEMENT: 'switch_mode_engagement',
  CLOSED_CAPTIONS_BASIC_SCREEN_ENGAGEMENT: 'closed_captions_basic_screen_engagement',
  CLOSED_CAPTIONS_PROPERTIES_SCREEN_ENGAGEMENT: 'closed_captions_properties_screen_engagement ',
  SETTINGS_BUTTON: 'settings_button',
  SETTINGS_MENU_SELECTION: 'settings_menu_selection',
  USERS_ENGAGEMENT: 'Users_engagement',
  INVITATIONS_ENGAGEMENT: 'Invitations_engagement',
  GROUPS_ENGAGEMENT: 'Groups_engagement',
  BASIC_INFO_ENGAGEMENT: 'basic_info_engagement',
  EDIT_PROFILE_PICTURE_ENGAGEMENT: 'edit_profile_picture_engagement',
  REMOVE_PROFILE_PICTURE: 'remove_profile_picture',
  UPDATE_PROFILE_PICTURE: 'update_profile_picture',
  PASSWORD_ENGAGEMENT: 'password_engagement',
  RESET_PASSWORD_VIA_EMAIL_ENGAGEMENT: 'Reset_password_via_email_engagement',
  USER_MANAGEMENT_SEARCH: 'user_management_search',
  GROUPS_SEARCH: 'Search_group_engagement',
  USERS_FILTER: 'Users_filters',
  USER_ACTIVE_ENGAGEMENT: 'user_active_engagement',
  EDIT_GROUPS_AND_ROLES_ENGAGEMENT: 'edit_Group&roles_engagement',
  ACTIONS_ENGAGEMENT: 'Actions_engagement',
  BULK_REMOVE_ENGAGEMENT: 'Bulk_remove_engagement',
  RESEND_ENGAGEMENT: 'Resend_engagement',
  INVITE_NEW_USER_ENGAGEMENT: 'Invite_new_user_engagement',
  ADD_NEW_USERS_TO_GROUP: 'Add_new_users_to_groups ',
  GALLERY_UPLOAD_ENGAGEMENT: 'gallery_upload_engagement',
  CAMERA_UPLOAD_ENGAGEMENT: 'camera_upload_engagement',
  VIDEO_UPLOAD_ENGAGEMENT: 'video_upload_engagement',
  REPLACE_CLIP_AUDIO: 'replace_clip_audio',
  REVERT_CLIP_AUDIO: 'revert_clip_audio',
  REPLACE_TIMELINE_AUDIO: 'replace_timeline_audio',
  REVERT_TIMELINE_AUDIO: 'revert_timeline_audio',
  ADD_ELEMENT: 'add_element',
  REMOVE_ELEMENT: 'remove_element',
  ASSET_SELECTION_NEXT: 'asset_selection_next',
  ASSET_IMPORT_FINALIZED: 'asset_import_finalized',
  PAGE_NAVIGATION: 'page_navigation',
  CHIP_SELECTION: 'chip_selection',
  ARTICLE_TO_VIDEO: 'article_to_video',
  VIDEO_EFFECTS: 'video_effects_engagment',
  ASSET_MENU_ACTION: 'asset_menu_action',
  LIBRARY_ASSET_PREVIEW_ACTION: 'library_asset_preview_action',
  FILTER_CHIP_SELECT: 'filter_chip_select',
  EDIT_DUBBING: 'edit_dubbing',
  CROP_THUMBNAIL: 'crop_thumbnail',
  TRANSCRIPTION_ENGAGEMENT: 'transcription_engagement',
  TRANSCRIPTION_SEARCH_ENGAGEMENT: 'transcription_search_engagement',
  TRANSCRIPTION_ADD_TO_TIMELINE_ENGAGEMENT: 'transcription_add_to_timeline_engagement',
})

export const TRACKER_CONTEXT = Object.freeze({
  ...constants.TRACKER_CONTEXT_COMMON,
  TIMELINE: 'timeline',
  LIBRARY: 'library',
  GAMES_TABLE: 'games_table',
  PLAYER: 'player',
  STREAMS_TABLE: 'streams_table',
  STORY: 'story',
  STORY_PAGE: 'story_page',
  LABELS: 'labels',
  MODE_SWITCH: 'mode_switch',
  FAB: 'fab',
  ELEMENTS_TAB: 'elements',
  LAYERS_TAB: 'layers',
  GETTY: 'getty',
  WORKSPACE_TOOLBAR: 'workspace_toolbar',
})

export const TRACKER_SUB_CONTEXT = Object.freeze({
  ...constants.TRACKER_SUB_CONTEXT_COMMON,
  EXTERNAL_AUDIO: 'external audio',
  VIDEO: 'video',
  STORY: 'story',
  INTERLEAVED_AUDIO: 'interleaved audio',
  TEMPLATE: 'template',
  TOOLBAR: 'toolbar',
  CROP: 'crop',
  VIDEO_SETTINGS: 'video_settings',
  GIF_SETTINGS: 'GIF_settings',
  ASSETS: 'assets',
  PBP: 'pbp',
  VIDEOS: 'videos',
  MOMENTS: 'moments',
  CLIP_PLAYER: 'clip_player',
  SIDE_PANEL: 'side panel',
  UPPPER_PROGRESS_BAR: 'upper_progress_bar',
  LOWER_PROGRESS_BAR: 'lower_progress_bar',
  GAMES: 'games',
  PROGRAMS: 'programs',
  CHANNELS: 'channels',
  SEARCH: 'search',
  CLEAR_FILTERS: 'clear_filters',
  STATUS: 'status',
  LABELS: 'labels',
  LABEL_TYPE: 'label_type',
  LIVE_INDICATION: 'live_indication',
  TITLE: 'title',
  STORY_GRID: 'story_grid',
  TEXT: 'cta_text',
  BACKGROUND_COLOR: 'background_color',
  TEXT_COLOR: 'text_color',
  TYPE: 'type',
  WEB_URL: 'web_url',
  ANDROID_URL: 'android_url',
  IOS_URL: 'ios_url',
  CLOSED_CAPTIONS: 'closed captions',
  MARKERS: 'marker',
  TRANSCRIPTIONS: 'transcription',
  UPLOAD_ASSETS: 'upload assets',
  MUSIC_VIOLATIONS: 'music violations',
  CLEAN_CANVAS_TEXT: 'text',
  CLEAN_CANVAS_SHAPE: 'shape',
  CLEAN_CANVAS_IMAGE: 'image',
  CLEAN_CANVAS_LOGO: 'logo',
  CLEAN_CANVAS_UPLOAD: 'upload',
  IMAGE_ACTION: 'image_action',
})

export const TRACKER_PUBLISH_REFERRER = Object.freeze({
  STREAM: 'Stream',
  LIBRARY: 'Library',
  TIMELINE: 'Timeline',
} as const)

export const TRACKER_CTA_REFERRER = Object.freeze({
  ...TRACKER_PUBLISH_REFERRER,
  GAMES_TABLE: 'Games table',
} as const)
